import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './global-nav.css';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logos/mb-logo.png';
import ytLogo from '../../assets/images/logos/youtube.png';
// import gLogo from '../../assets/images/logos/google.png';
import gWordLogo from '../../assets/images/logos/google-word.png';
import ytLogoSmall from '../../assets/images/logos/ytSmall.png';
import googleSmall from '../../assets/images/logos/googleSmall.png';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { 
	AppBar,
	Toolbar,
	Typography
} from '@mui/material';
import { Sling as Hamburger } from 'hamburger-react'
import { setLoginVisible, setMenuVisible } from '../../features/dialogControl/dialogControlSlice';


const GlobalNav = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const menuVisible = useSelector((state) => state.dialogControl.menuVisible);
	const [isGoogleWorthy,setGoogleWorthy] = useState(false);
	// blur if not logged in
		useEffect(() => {
				const user = JSON.parse(localStorage.getItem('mb-vox-auth'));
				if (user) {
					setGoogleWorthy(true);
				} else {
					setGoogleWorthy(false);
				}
		}, []);


	const handleUserClick = () => {
		dispatch(setLoginVisible(true));
	};

	const handleToggleMenu = () => {
		dispatch(setMenuVisible(!menuVisible));
	}

	
	return (
		<AppBar position="static">
			<Toolbar style={{ 
				justifyContent: 'space-between',
				backgroundColor: '#000000' 
			}}>
				<div className='logo-outer-container'>
				<NavLink className='nav-link'to='/'>
					<div className='logo-container'>
							<div className='left-block'>
								<img className='main-logo' src={logo} alt='' />
								<div className='title-container'>
									<div className='title'>MUSICBLOX</div>
									<div className='title-subscript'>.AI</div>
								</div>
							</div>
						<div className='left-block-subline'>A division of MediaBlox, Inc.</div>
					</div>
				</NavLink>


					{isGoogleWorthy && location.pathname === '/voice' &&
						<div className='service-logo-container'>
							<img className='service-logo' src={gWordLogo} alt='' />
							<img className='service-logo' src={ytLogo} alt='' />
							<img className='service-logo-small' src={googleSmall} alt='' />
							<img className='service-logo-small' src={ytLogoSmall} alt='' />
						</div>
					}
				</div>
				
				<Typography className='right-block'>
					<NavLink className={`nav-link ${location.pathname === '/' ? 'nav-selected' : '' }`} to='/'>HOME</NavLink>
					<NavLink className={`nav-link ${location.pathname === '/artists' ? 'nav-selected' : '' }`} to='/artists'>ARTISTS</NavLink>
					<NavLink className={`nav-link ${location.pathname === '/tracks' ? 'nav-selected' : '' }`}to='/tracks'>TRACKS</NavLink>
					<NavLink className={`nav-link ${location.pathname === '/voice' ? 'nav-selected' : '' }`} to='/voice'>VOICE</NavLink>
					<AccountCircleIcon
						className='nav-link' 
						onClick = {() => handleUserClick()}
					/>
				</Typography>
				<div className='nav-mini'>
					<Hamburger
						type='button'
						className='slip'
						toggled={menuVisible}
						direction='right'
						onToggle={() => handleToggleMenu()}
					/>
            	</div>
			</Toolbar>
		</AppBar>
  	)
}

export default GlobalNav;